import { render, staticRenderFns } from "./UpperLimitTable.vue?vue&type=template&id=40fc2dce&scoped=true"
import script from "./UpperLimitTable.vue?vue&type=script&lang=js"
export * from "./UpperLimitTable.vue?vue&type=script&lang=js"
import style0 from "./UpperLimitTable.vue?vue&type=style&index=0&id=40fc2dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fc2dce",
  null
  
)

export default component.exports